import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslate } from './TranslationText'
import { showWordsByNumber } from '../helper/showFirstSixWords';
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function NewsItemHome({ item, windowWidtht }) {
  const { translate } = useTranslate();
  const currentLanguage = localStorage.getItem("eahsLang") ?? "en";

  return (
    <>
      <div draggable='false' className="more_news_image_container " style={{ aspectRatio: '463 / 437'  }}>
        <img src={`${MediaBaseURL}${item.Item_CoverImage}`} className='justRotate h-100' alt="post" style={{ width: 'unset' }} />
        <div className="more_news_image_overlay"></div>
        <div className='moreNewsTextBox'>
          <div draggable='false' className="more_news_post_title  rtl " style={{ fontSize: 15,paddingLeft:currentLanguage=='en'?0:34,paddingRight:currentLanguage=='en'?34:0, bottom: windowWidtht >= 1400 ? '6rem' : windowWidtht >= 500 ? '4.5rem' : windowWidtht >= 424 ? '8rem' : '4.5rem' }}>
            {showWordsByNumber(item.Item_Title , 13)}
          </div>
          <div style={{display:'flex' , flexDirection:'row' , justifyContent:'space-between' , direction:'ltr' , paddingRight:34 , alignItems:'flex-end' , marginTop:0 }}>
            <p draggable='false' className="more_news_post_text rtl" style={{ fontSize: 12 , marginTop:10 }}>
              { item.Item_Date}
            </p>
            {/* <p draggable='false' className="justRotate" style={{ fontSize: 12, marginBottom:11 }}>
              <button draggable='false' style={{ fontSize: 12, }} className={`btn btn-outline-light rounded-pill ${windowWidtht >= 1400 ? 'px-5' : 'px-4'}  `}>{translate('web.more', 'More')}</button>
            </p> */}
          </div>
        </div>
      </div>

    </>
  )
}
